/*
 * Public API Surface of inova-core
 */

export * from './notifications.service'


